import { DTO } from '../DTO'

export class LessonClass extends DTO {
  id: number
  name: string
  studentNameExample: string
  remainStudentCount: number
  teacherNameExample: string
  remainTeacherCount: number

  constructor(data: res.LessonClass) {
    super()
    this.id = data.id
    this.name = data.name
    this.studentNameExample = data.studentNameExample
    this.remainStudentCount = data.remainStudentCount
    this.teacherNameExample = data.teacherNameExample
    this.remainTeacherCount = data.remainTeacherCount
  }
}
